<div class="ttmodal" *ngIf="isPopup">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
           
        </span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
  </div>

<div *ngIf="isLoading" class="spinner-container">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<div *ngIf="!isLoading && EquipmentComponentWearModel?.length > 0">
  <div class="row">
    <div class="col-12 label-padding">
      <mat-radio-group
        [(ngModel)]="measurementDisplayType"
        (change)="onMeasurementDisplayTypeChange($event.value)"
        class="measurement-radio-group">

        <mat-radio-button [value]="1">
          All Measurement Point
        </mat-radio-button>

        <mat-radio-button [value]="2">
          Average by Component
        </mat-radio-button>

      </mat-radio-group>
    </div>

    <div class="col-12 mb-3">
      <div class="compart-type-filter">
        <mat-label class="label_Text">
          Display The Following Plot
        </mat-label>

        <mat-checkbox
          *ngFor="let item of EquipmentCompartmentTypeModel"
          [(ngModel)]="item.IsShovel"
          (change)="onCompartTypeChange(item)">
          {{ item.CompartTypeName }}
        </mat-checkbox>
      </div>
    </div>

    <div
      class="col-md-12"
      *ngFor="let chart of chartConfigs; let i = index; trackBy: trackByCompart"
      [hidden]="!isCompartTypeVisible(chart.compartTypeId)">

      <div class="text-end">
        <button
          mat-raised-button
          color="warn"
          (click)="openTablePopup(chart)">
          View Data
        </button>
      </div>
<div class="shovel-chart-wrapper">
      <fusioncharts
        [id]="'chart_' + chart.compartTypeId + '_' + i + '_' + (chart.renderKey ?? 0)"
        [width]="'1800'"
        [height]="'600'"
        [type]="'scatter'"
        [dataFormat]="'json'"
        [dataSource]="chart.dataSource"
        (legendItemClicked)="onLegendItemClicked($event, chart)">
      </fusioncharts>
</div>
    </div>
  </div>
</div>

<div
  *ngIf="!isLoading && !EquipmentComponentWearModel?.length"
  class="text-center">
  No data available.
</div>